<!-- custom-select.component.html -->
<div class="select-wrapper">
    <div class="select-trigger" tabindex="0" (click)="toggle()">
      {{ selectedLabel }}
      <span class="chevron" [class.open]="open"></span>
    </div>
  
    <div
      #panel
      class="select-panel"
      *ngIf="open"
      [style.max-height.px]="panelHeight"
      tabindex="0"
    >
      <div
        class="option"
        *ngFor="let opt of options; let i = index"
        [class.active]="i === active"
        [class.selected]="opt.value === value"
        (click)="select(opt)"
      >
        {{ opt.label }}
      </div>
    </div>
  </div>
  